module.exports = __webpack_public_path__ + "img/nav-effect.02ee48bb.png";